import request from "@/utils/request";
// 圈子列表
const getCircleList = (params) =>
  request.post("/laiHi/web/circle/circleList", params);
// 修改圈子状态
const editCircleStatus = (params) =>
  request.post("/laiHi/web/circle/modifyCircleStatus", params);
// 圈子详情
const getCircleDetails = (params) =>
  request.post("/laiHi/web/circle/circleListInfo", params);
// 批量删除圈子
const deleteCircle = (params) =>
  request.post("/laiHi/web/circle/deleteCircle", params);
// 查询评论列表
const getCommentList = (params) =>
  request.post("/laiHi/web/circle/circleCommentList", params);
// 修改评论状态
const editComment = (params) =>
  request.post("/laiHi/web/circle/modifyCircleCommentStatus", params);
// 删除评论
const deleteComment = (params) =>
  request.post("/laiHi/web/circle/deleteCircleComment", params);
export {
  getCircleList,
  editCircleStatus,
  getCircleDetails,
  deleteCircle,
  getCommentList,
  editComment,
  deleteComment,
};
